/* eslint-disable no-var */
/* eslint-disable camelcase */
//USED by DRUSHIM
import Vue from "vue";
import drushim_lodash from "lodash";
//logSSAEventToAPI is imported here because it can only be imported in top level modules
import { objectWalker } from "@/lib/utils";
import { fetchSSADATA, newData } from "@/assets/js/ssa/ssaData";

function LogSSA(eventName) {
    this.logger.logEvent(eventName);
}

// search
const LogSSASearchEvent = LogSSA;

const LogSSARecommenderListingsDisplayed = drushim_lodash.partial(LogSSA, "RecommenderListingsDisplayed");

// replaced Listing events with recommenderUUID
//const LogSSARecommenderListingClicked = drushim_lodash.partial(LogSSA, "RecommenderListingClicked");

// search company
const LogSSASearchCompanyEvent = LogSSA;

/**
 * convert all js:<propertyName> to a function which returns the variable value
 * convert eventDefinition to use local values from view model instead of global variables
 * @param {object} eventDefinition event definition
 * @param {object} vm - view model for the ssa data
 * @returns {object} eventDefinition
 */
function getEventDefinition(eventDefinition, vm) {
    function changeEventDefinition(val, key, obj) {
        if (drushim_lodash.startsWith(val, "js:")) {
            obj[key] = () => vm[val.slice(3)];
        }
    }

    eventDefinition = drushim_lodash.cloneDeep(eventDefinition);
    objectWalker(eventDefinition, { fn: changeEventDefinition });

    eventDefinition.CommonListingEvent.features = function features() {

        return vm.features;
    };

    eventDefinition.SearchPaging.featuredListingIds = function featuredListingIds(
        event
    ) {
        return { preferred: vm.PreferredIds, hot: vm.HotIds };
    };

    eventDefinition.SearchPaging.filters = () => vm.ssa_Filters;

    eventDefinition.RecommenderListingsDisplayed.featuredListingIds = function featuredListingIds(
        event
    ) {
        // console.log(vm.featuredListingIds)
        return vm.featuredListingIds;
    };
    eventDefinition.RecommenderListingsDisplayed.similarListings = function similarListings(
        event
    ) {
        // console.log(vm.featuredListingIds)
        return vm.similarListings;
    };

    //eventDefinition.RecommenderListingClicked.features = () =>
    //    vm.IsRecommendadJobPreferred ? ["preferred"] : [];

    return eventDefinition;
}

export function fetch(vm) {
    return fetchSSADATA().then((data) => drushim_lodash.assign(vm, data));
}

export function copy(vm) {
    const copy = new SSAVue({ data: newData(vm.$data) });
    copy._ssa = vm._ssa;
    copy._ssaparent = vm;
    copy._ssacopy = true;

    return copy;
}

var ssaLogger;

const SSAVue = Vue.extend({
    props: ["msg"],
    data: () => newData(),
    computed: {
        logger() {
            return ssaLogger;
        },
    },
    methods: {
        LogSSASearchEvent,
        LogSSA,
        LogSSARecommenderListingsDisplayed,
        //LogSSARecommenderListingClicked, // replaced listing event with recommenderUUID
        fetchSSADATA,
        fetch() {
            return fetch(this);
        },
        copy() {
            return copy(this);
        },

        /**
         * setEventDefinition - set Event Definition to current instance of SSAVue
         * @memberof SSAVue
         */
        setEventDefinition() {
            const { ssaED, eventDefinition } = this._ssa;
            const newED = getEventDefinition(ssaED, this);
            drushim_lodash.assign(eventDefinition, newED);
            return this;
        },

        readCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },

        async logBulk(method, args) {
            try {
                const { eventName, jobcodes } = args;
                const eventId = this.getEventId(eventName);

                const params = new URLSearchParams();
                params.append("eventNumber", eventId);
                jobcodes.forEach((element) => {
                    params.append("jobcodes", element);
                });
                const requestConfig = {
                    params: params,
                    headers: {
                        withCredentials: true,
                        Authorization: decodeURIComponent(
                            this.readCookie("drushim_auth_token.local")
                        ),
                    },
                };

                let events = await fetchSSADATA({ requestConfig });

                if (!Array.isArray(events)) {
                    events = [events];
                }

                for (const eventData of events) {
                    const copy = this.copy();
                    drushim_lodash.assign(copy, eventData);
                    copy.sendRequest(method, eventName);
                }
            } catch (e) {
                console.error("fetch ssa data failed (logbulk)", e);
            }
        },
        async log(method, args) {
            try {
                const { eventName, jobcode, jobindex, ssasource } = args;
                const eventId = this.getEventId(eventName);

                const requestConfig = {
                    params: { eventNumber: eventId, jobcode, jobindex, ssasource },
                    headers: {
                        withCredentials: true,
                        Authorization: decodeURIComponent(
                            this.readCookie("drushim_auth_token.local")
                        ),
                    },
                };

                let events = await fetchSSADATA({ requestConfig });

                if (!Array.isArray(events)) {
                    events = [events];
                }
                for (const eventData of events) {
                    const copy = this.copy();
                    drushim_lodash.assign(copy, eventData);
                    copy.sendRequest(method, eventName);
                }
            } catch (e) {
                console.error("fetch ssa data failed (log)", e);
            }
        },

        async logResponse(method, args) {

            let events = args;
            try {
                if (!Array.isArray(events)) {
                    events = [events];
                }

                for (const eventData of events) {
                    const copy = this.copy();
                    drushim_lodash.assign(copy, eventData);
                    copy.sendRequest(method, eventData.EventName);
                }
            } catch (e) {
                console.error("fetch ssa data failed", e);
            }
        },

        sendRequest(method, ...args) {
            this.setEventDefinition();
            drushim_lodash.invoke(this, method, ...args);
        },

        getEventId(eventName) {
            switch (eventName) {
                case "Search":
                    return 1;
                case "SearchFaceting":
                    return 2;
                case "SearchPaging":
                    return 3;
                case "ListingView":
                    return 4;
                case "ListingOAFSent":
                    return 5;
                case "ListingOAFClicked":
                    return 6;
                case "RecommenderListingsDisplayed":
                    return 7;
                //case "RecommenderListingClicked": // replaced listing event with recommenderUUID
                //    return 8;

                case "ListingAddedToOAFBulk":
                    return 9;
                case "ListingOAFClickedBulk":
                    return 10;
                case "ListingOAFSentBulk":
                    return 11;
            }
            return 0;
        },
    },
    template: "<div>{{msg}}</div>",
});

export default function initSSA({ serviceUrl, ssaED, SSALogger, setLogger }) {
    /* SSALogger Instance creation */
    const vm = new SSAVue();
    const eventDefinition = getEventDefinition(ssaED, vm);
    vm._ssa = { eventDefinition, ssaED };

    ssaLogger = new SSALogger({
        serviceUrl,
        eventDefinition,
        'brand': 'drushim' //instruct ssaLogger to do in postEvent():
        //  logSSAEventToAPI(event, event.eventName)
        //  //remove drushim properties
        //  delete event.ABTestCookie
        //  delete event.CookieExperation
    });
    setLogger(ssaLogger);

    const ssa = {
        logger: ssaLogger,
        vm,
        SSAVue,
        copy,
        fetch,
    };

    return ssa;
}





export { SSAVue };
